module.exports = __webpack_public_path__ + "media/rite_of_battle.3dee3512.mp3";